import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type SkillAnalyticsScope, type SkillAnalyticsType } from './skillAnalytics';
import META from './useTrackSkillCreated.meta';

export type UseTrackSkillCreatedParams = {
  scope: SkillAnalyticsScope;
  skill_id: string;
  type: SkillAnalyticsType;
};

export const useTrackSkillCreated = () => {
  const { track } = useAnalyticsUtilities();

  const trackSkillCreated = useCallback(
    (params: UseTrackSkillCreatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSkillCreated };
};
